import { SelectableNumberInputOptions } from '@/coreDomainsModule/entities/inputOptions';
import { defineStore } from 'pinia';
import { reactive } from 'vue';

/**
 * プルダウン付き数値入力のStoreを管理する
 */
export const useSelectableNumberInputStore = defineStore('selectableNumberInput', () => {
  const state = reactive<ISelectableNumberInputState>({
    inputValue: 0.0,
    isSelectInput: false,
    isHoverSuggests: false,
  });

  /**
   * stateの初期化
   */
  const $reset = () => {
    state.inputValue = 0.0;
    state.isSelectInput = false;
    state.isHoverSuggests = false;
  };

  /**
   * stateの値を更新する
   * @param value - 更新する値
   */
  const updateInputValue = (value: number) => {
    state.inputValue = value;
  };

  /**
   * 選択されたサジェストによって値を更新する
   * @param suggestText - サジェストのテキスト
   * @param options - サジェストのオプション
   */
  const updateBySelectedSuggest = (suggestText: string, options: SelectableNumberInputOptions[]) => {
    const selectedOption = options.find((option) => option.text === suggestText);
    if (selectedOption) {
      state.inputValue = selectedOption.value;
    }
  };

  /**
   * サジェストにホバーした際の処理
   */
  const hoverSuggests = () => {
    state.isHoverSuggests = true;
  };
  /**
   * サジェストから離れた際の処理
   */
  const leaveSuggests = () => {
    state.isHoverSuggests = false;
  };
  /**
   * 入力欄を選択した際の処理
   */
  const selectInput = () => {
    state.isSelectInput = true;
  };
  /**
   * 入力欄から離れた際の処理
   */
  const leaveInput = () => {
    state.isSelectInput = false;
  };

  return {
    state,
    $reset,
    updateInputValue,
    updateBySelectedSuggest,
    hoverSuggests,
    leaveSuggests,
    selectInput,
    leaveInput,
  };
});

/**
 * プルダウン付き数値入力のStoreのState
 */
interface ISelectableNumberInputState {
  inputValue: number;
  isSelectInput: boolean;
  isHoverSuggests: boolean;
}
